import { NgModule } from "@angular/core";
import { NavbarComponent } from "./components/shared/navbar/navbar.component";
import { CadastrarUsuarioComponent } from "./components/pages/cadastrar-usuario/cadastrar-usuario.component";
import { UsuariosComponent } from "./components/pages/usuarios/usuarios.component";
import { EmpresasComponent } from "./components/pages/empresas/empresas.component";
import { CommonModule, DatePipe } from "@angular/common";
import { RouterLink, RouterModule } from "@angular/router";
import { AdminRoutingModule } from "./admin-routing.module";
import { NgApexchartsModule } from 'ng-apexcharts';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DashboardComponent } from "./components/pages/dashboard/dashboard.component";
import { EditarColaboradorComponent } from "./components/pages/editar-colaborador/editar-colaborador.component";
import { NgxSpinnerModule } from "ngx-spinner";

import { EdicaoConsumidorComponent } from "./components/pages/edicao-consumidor/edicao-consumidor.component";
import { ConsultaConsumidorComponent } from "./components/pages/consulta-consumidor/consulta-consumidor.component";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { AuditoriaComponent } from "./components/pages/auditoria/auditoria.component";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from "../../interceptors/auth.interceptor";
import { HistoriocoExpedienteComponent } from "./components/pages/historioco-expediente/historioco-expediente.component";
import { ServicosComponent } from "./components/pages/servicos/servicos.component";
import { ServicosRecadastroComponent } from "./components/pages/servicos-recadastro/servicos-recadastro.component";
import { ServicosPendentesComponent } from "./components/pages/servicos-pendentes/servicos-pendentes.component";
import { ServicosCadastroComponent } from "./components/pages/servicos-cadastro/servicos-cadastro.component";
import { ServicosInvalidosComponent } from "./components/pages/servicos-invalidos/servicos-invalidos.component";
import { ServicoDetalhesComponent } from './components/pages/servico-detalhes/servico-detalhes.component';
import { RoteiroColaboradorComponent } from "./components/pages/roteiro-colaborador/roteiro-colaborador.component";
import { ServicosNegativaComponent } from "./components/pages/servicos-negativa/servicos-negativa.component";

import { ClienteBaseComponent } from "./components/pages/cliente-base/cliente-base.component";
import { OrdemServicoComponent } from "./components/pages/ordem-servico/ordem-servico.component";
import { AnaliseComponent } from './components/pages/analise/analise.component';
import { DashboardAdminComponent } from './components/pages/dashboard-admin/dashboard-admin.component';
import { FinanceiroComponent } from "./components/pages/financeiro/financeiro.component";
import { FieldVerifyToggleComponent } from "../../shared/components/field-verify-toggle/field-verify-toggle.component";
import { SuporteComponent } from "./components/pages/suporte/suporte.component";
import { SuperadminComponent } from './components/pages/suporte/superadmin.component';


@NgModule({
    declarations: [
        NavbarComponent,
        CadastrarUsuarioComponent,
        UsuariosComponent,
        EmpresasComponent,
        EdicaoConsumidorComponent,
        ConsultaConsumidorComponent,
        DashboardComponent,
        DashboardAdminComponent,
        RoteiroColaboradorComponent,
        EditarColaboradorComponent,
        AuditoriaComponent,
        ServicosComponent,
        ServicosNegativaComponent,
        FinanceiroComponent,
        ServicosPendentesComponent,
        ServicosCadastroComponent,
        ServicosInvalidosComponent,
        ServicoDetalhesComponent,
        AnaliseComponent,
        ServicosRecadastroComponent,
        ClienteBaseComponent,
        OrdemServicoComponent,
        HistoriocoExpedienteComponent,
        FieldVerifyToggleComponent,
        SuporteComponent,
        SuperadminComponent
    ],
    imports: [
        CommonModule,
        RouterLink,
        AdminRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        NgxSpinnerModule,
        NgxMaskDirective,
        NgxMaskPipe,
        NgApexchartsModule,
    ],
    providers: [
        DatePipe,
        provideNgxMask(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ],
    exports: [
        DashboardComponent
    ]
})
export class AdminModule { }